module.exports = __webpack_public_path__ + "static/media/equal-salary-main-baner.b4fdcd52.png";